export const numPadTypes = {
  betAmount: 'betAmount',
  autoCashOutOdd: 'autoCashOutOdd',
};
